import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import Navbar from '../components/navbar/Navbar'; // Adjust the path to Navbar
import Footer from '../components/footer/Footer'; // Adjust the path to Footer

const NotFoundPage = () => {
    const navigate = useNavigate(); // Hook to handle navigation

    const goToHome = () => {
        navigate('/'); // Navigates to the home page
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            justifyContent: 'space-between',
            backgroundColor: '#1a1a1a', // Dark background color
            color: 'white',
        }}>
            <Navbar />

            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1,
                textAlign: 'center',
            }}>
                {/* "Oops... WRONG TURN" above 404 */}
                <p style={{
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: '1.5rem',
                    color: 'white', 
                    marginBottom: '20px',
                }}>
                    Oops... Wrong Turn 
                </p>

                {/* "404" text */}
                <h1 style={{
                    fontFamily: 'navbar-font',
                    color: 'white', // Change 404 text color to white
                    fontSize: '6rem',
                    fontWeight: 'bold',
                }}>
                    404 
                </h1>

                {/* "PAGE NOT FOUND :(" text below 404 */}
                <p style={{
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: '1.5rem',
                    color: 'white',
                    marginTop: '20px',
                }}>
                    PAGE NOT FOUND :(
                </p>

                {/* Go to home link */}
                <p onClick={goToHome} style={{
                    color: 'white',
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: '1.2rem',
                    marginTop: '20px',
                    textDecoration: 'underline',
                    cursor: 'pointer', // Makes the text clickable
                }}>
                    Go To Home Page
                </p>
            </div>

            <Footer />
        </div>
    );
};

export default NotFoundPage;
